var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-content',[_c('div',{staticClass:"loader text-xs-center pt-5"},[_c('span',[_vm._v("Logging in")]),_c('v-progress-circular',{staticClass:"loadingCircle",attrs:{"indeterminate":""}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }